import React, { Component } from "react";
import { connect } from "react-redux";
import HelmetComponent from "../../components/shared/Helmet";
import { SiteConstants } from "../../constants/constant";
import NoSearchResults from "./StartSearch";
import { VideoListingComponent } from "./videosListing";
import { bindActionCreators } from "redux";
import { LoaderComponent } from "../../components/loader";
import ObjectList from "../../components/searchComponents/objectList";
import EventList from "../../components/searchComponents/eventList";
import TopicList from "../../components/searchComponents/topicList";

// actions
import {
  getVodSearchDataAction,
  resetSearchResults,
  showLoader,
  hideLoader,
  setSignupModalStatus
} from "../../actions";
import {
  IsEmpty,
  fetchSearchResult,
  followButtonClicked,
  redirectToCompanyUrl,
  redirectToExpertUrl,
  redirectToUrl,
  redirectToSeriesUrl
} from "../../util/commonFunctions";
import cosmeticConfig from '../../../config/cosmeticConfig';
import { getEnv } from "../../../helpers/env";

let timer;
let searchText;

class Search extends Component {
  constructor(props) {
    super(props);
    this.refInput = React.createRef();
  }

  state = {
    userInput: "",
    isLoader: false,
    offset: cosmeticConfig.search.OFFSET,
    max: cosmeticConfig.search.MAX,
    lastScrollTop: 0,
    searchVodResults: null,
    searchEventResults: [],
    searchCompanyResults: [],
    searchExpertResults: [],
    searchTopicResults: [],
    searchSeriesResults: [],
    signInEvent: false,
    queryFilter: 'newest',
    resultFilter: 'videos',
  };

  handleKeyPress = event => {
    searchText = event.target.value;
    const eventCode = event.which || event.keyCode;
    const elementId = event.target.getAttribute("id");
    if (
      eventCode == SiteConstants.ENTER_KEY_EVENT_CODE &&
      searchText.trim().length > 0
    ) {
      try {
        $("#form").submit(() => false);
      } catch (err) {
        // console.log('Error: ' + err);
      }
    }
  };

  resetSearch = flag => {
    this.setState(
      {
        userInput: "",
        searchVodResults: null,
        searchText: "",
        offset: 0,
        searchEventResults: [],
        searchCompanyResults: [],
        searchExpertResults: [],
        searchTopicResults: [],
        searchSeriesResults: []
      },
      () => {
        this.searchInput.value = "";
        this.props.resetSearchResults();
        if (flag) {
          if (this.state.signInEvent) { // if search intent is initiated from this page
            this.props.history.push("/"); // static redirection to control sign in goBack edge case
          } else {
            this.props.history.goBack();
          }
        }
      }
    );
  };

  handleValueChange = event => {
    searchText = event.target.value;
    this.setState({
      userInput: searchText
    });
  };

  handleKeyUp = () => {
    const thisReference = this;

    clearTimeout(timer);
    timer = setTimeout(
      thisReference.handleChange,
      SiteConstants.doneTypingInterval
    );
  };

  handleChange = () => {
    if (searchText.trim().length >= SiteConstants.MIN_SEARCH_TEXT_LENGTH) {
      this.setState({resultFilter: 'videos'});
      this.searchVods(searchText.trim());
      fetchSearchResult(this.fetchCompanySearchResultHandler, this.props.currentLanguage, localStorage.getItem("token"), [], searchText.trim(), 'company', 0, 3);
      fetchSearchResult(this.fetchExpertSearchResultHandler, this.props.currentLanguage, localStorage.getItem("token"), [], searchText.trim(), 'expert', 0, 3);
      fetchSearchResult(this.fetchTopicSearchResultHandler, this.props.currentLanguage, localStorage.getItem("token"), [], searchText.trim(), 'topic', 0, 3);
      fetchSearchResult(this.fetchSeriesSearchResultHandler, this.props.currentLanguage, localStorage.getItem("token"), [], searchText.trim(), 'series', 0, 3);
      fetchSearchResult(this.fetchEventSearchResultHandler, this.props.currentLanguage, localStorage.getItem("token"), [], searchText.trim(), 'event', 0, 3);
    }
    if (searchText.trim().length == "") {
      this.resetSearch(false);
    }
  };

  fetchEventSearchResultHandler = (response, error) => {
    this.setState({
      searchEventResults: response
    });
  }

  fetchCompanySearchResultHandler = (response, error) => {
    this.setState({
      searchCompanyResults: response
    });
    if (!IsEmpty(localStorage.getItem("followObject"))) {
      let objectId = JSON.parse(localStorage.getItem("followObject")).objectId;
      let objectType = JSON.parse(localStorage.getItem("followObject")).objectType;
      if (objectType == 'company') {
        this.followObject(objectId, objectType);
        localStorage.removeItem("followObject");
      }
    }
  }

  fetchExpertSearchResultHandler = (response, error) => {
    this.setState({
      searchExpertResults: response
    });
    if (!IsEmpty(localStorage.getItem("followObject"))) {
      let objectId = JSON.parse(localStorage.getItem("followObject")).objectId;
      let objectType = JSON.parse(localStorage.getItem("followObject")).objectType;
      if (objectType == 'expert') {
        this.followObject(objectId, objectType);
        localStorage.removeItem("followObject");
      }
    }
  }

  fetchSeriesSearchResultHandler = (response, error) => {
    this.setState({
      searchSeriesResults: response
    });
    if (!IsEmpty(localStorage.getItem("followObject"))) {
      let objectId = JSON.parse(localStorage.getItem("followObject")).objectId;
      let objectType = JSON.parse(localStorage.getItem("followObject")).objectType;
      if (objectType == 'series') {
        this.followObject(objectId, objectType);
        localStorage.removeItem("followObject");
      }
    }
  }

  fetchTopicSearchResultHandler = (response, error) => {
    this.setState({
      searchTopicResults: response
    });
    if (!IsEmpty(localStorage.getItem("followObject"))) {
      let objectId = JSON.parse(localStorage.getItem("followObject")).objectId;
      let objectType = JSON.parse(localStorage.getItem("followObject")).objectType;
      if (objectType == 'topic') {
        this.followObject(objectId, objectType);
        localStorage.removeItem("followObject");
      }
    }
  }

  followObject = (objectId, objectType) => {
    if (localStorage.getItem("token")) {
      if (objectType == "company") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), objectId);
      } else if (objectType == "expert") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
      } else if (objectType == "topic") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
      } else if (objectType == "series") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
      }
    } else {
      let followObject = { objectId: objectId, objectType: objectType };
      localStorage.setItem("followObject", JSON.stringify(followObject));
      localStorage.setItem("searchTerm", this.state.userInput);
      this.props.setSignupModalStatus(true, "signin");
    }
  }

  followButtonClickedRespHandler = (response, error) => {
    if (response) {
      this.updateFollowBtnStatus(response.objectId, response.objectType);
    }
  }

  updateFollowBtnStatus = (objectId, objectType) => {

    if (objectType == "company" && this.state.searchCompanyResults.length > 0) {
      let updated_companies = [];
      Object.values(this.state.searchCompanyResults).map(values => {
        if (values?.id == objectId) {
          values.isFollowing = !values.isFollowing;
        }
        updated_companies.push(values);
      });
      this.setState({
        searchCompanyResults: updated_companies
      });
    }

    if (objectType == "expert" && this.state.searchExpertResults.length > 0) {
      let updated_experts = [];
      Object.values(this.state.searchExpertResults).map(values => {
        if (values?.id == objectId) {
          values.isFollowing = !values.isFollowing;
        }
        updated_experts.push(values);
      });
      this.setState({
        searchExpertResults: updated_experts
      });
    }

    if (objectType == "topic" && this.state.searchTopicResults.length > 0) {
      let updated_topics = [];
      Object.values(this.state.searchTopicResults).map(values => {
        if (values?.id == objectId) {
          values.isFollowing = !values.isFollowing;
        }
        updated_topics.push(values);
      });
      this.setState({
        searchTopicResults: updated_topics
      });
    }

    if (objectType == "series" && this.state.searchSeriesResults.length > 0) {
      let updated_series = [];
      Object.values(this.state.searchSeriesResults).map(values => {
        if (values?.id == objectId) {
          values.isFollowing = !values.isFollowing;
        }
        updated_series.push(values);
      });
      this.setState({
        searchSeriesResults: updated_series
      });
    }

  }

  searchVods = async (searchText, filter) => {
    const { max, offset } = this.state;
    const { getVodSearchDataAction, currentLanguage } = this.props;
    await getVodSearchDataAction({ searchText, offset, max, language: currentLanguage, filter });
  };

  componentDidMount() {
    this.lazyLoadContainer = React.createRef();
    this.searchInput.focus();
    window.addEventListener("scroll", this.onScroll, false); // bind scroll event
    if (!IsEmpty(localStorage.getItem("userLastKnownLocation")) && decodeURIComponent(localStorage.getItem("userLastKnownLocation")) == getEnv("BASE_URL") + this.props.match.url) { // if search intent is initiated from this page
      this.setState({
        signInEvent: true
      });
      localStorage.removeItem("userLastKnownLocation");
      if (!IsEmpty(localStorage.getItem("searchTerm"))) {
        const savedSearchTerm = localStorage.getItem("searchTerm");
        this.setState({
          userInput: savedSearchTerm
        });
        localStorage.removeItem("searchTerm");
        this.searchVods(savedSearchTerm);
        fetchSearchResult(this.fetchCompanySearchResultHandler, localStorage.getItem("token"), [], savedSearchTerm, 'company', 0, 3);
        fetchSearchResult(this.fetchExpertSearchResultHandler, localStorage.getItem("token"), [], savedSearchTerm, 'expert', 0, 3);
        fetchSearchResult(this.fetchTopicSearchResultHandler, localStorage.getItem("token"), [], savedSearchTerm, 'topic', 0, 3);
        fetchSearchResult(this.fetchSeriesSearchResultHandler, localStorage.getItem("token"), [], savedSearchTerm, 'series', 0, 3);
        fetchSearchResult(this.fetchEventSearchResultHandler, localStorage.getItem("token"), [], savedSearchTerm, 'event', 0, 3);
        searchText = savedSearchTerm;
      }
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.onScroll, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.queryFilter !== this.state.queryFilter && this.state.queryFilter) {
      this.searchVods(this.state.userInput.trim(), this.state.queryFilter.toLocaleLowerCase());
    }
  }
  ///  lazy load on scroll
  onScroll = () => {
    const {
      searchReducer: { isSubMenuDataLoading, subMenuData }
    } = this.props;
    const {
      lastScrollTop
    } = this.state
    const {
      top: containerTop
    } = this.lazyLoadContainer.current.getBoundingClientRect();
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      this.setState({
        lastScrollTop: st <= 0 ? 0 : st
      })
      // downscroll code
    } else {
      this.setState({
        lastScrollTop: st <= 0 ? 0 : st
      })
      return;
      // upscroll code
    }
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
      const listing =
        subMenuData &&
        Object.values(subMenuData).map(values => values.rows);
      const lastList =
        Array.isArray(listing) && listing.length && listing[listing.length - 1];
      if (
        !isSubMenuDataLoading &&
        containerTop < 100 &&
        lastList &&
        lastList.length
      ) {
        this.setState(
          prevState => ({
            offset: prevState.offset + prevState.max
          }),
          () => {
            if (
              searchText.trim().length >= SiteConstants.MIN_SEARCH_TEXT_LENGTH
            ) {
              this.searchVods(searchText.trim());
            }
          }
        );
      }
    }
  };

  render = () => {
    const { searchReducer } = this.props;
    const { subMenuData = {}, isSubMenuDataLoading } = searchReducer;

    let listing = [];
    let totalResults = 0;

    if (!IsEmpty(this.state.userInput)) {
      listing =
        subMenuData &&
        Object.values(subMenuData).map(values => {
          totalResults += values.rows
            ? values.rows.length
            : 0;
          return values.rows;
        });
    }

    const isLoggedin =
      !IsEmpty(this.props.token) ||
      this.props.location.pathname.indexOf("signup") > 0;

    let globalTotalResult = totalResults + this.state.searchEventResults.length + this.state.searchCompanyResults.length + this.state.searchExpertResults.length + this.state.searchTopicResults.length + this.state.searchSeriesResults.length

    const isVideos = this.state.resultFilter === 'videos';
    const hasVideos = !IsEmpty(this.state.userInput) && listing;
    const isSeries =  this.state.resultFilter === 'series';
    const hasSeries =  this.state.searchSeriesResults.length > 0;
    const isCompanies = this.state.resultFilter === 'companies';
    const hasCompanies =  this.state.searchCompanyResults.length > 0;
    const isExperts = this.state.resultFilter === 'experts';
    const hasExperts =  this.state.searchExpertResults.length > 0;
    const isTopics = this.state.resultFilter === 'topics';
    const hasTopics =  this.state.searchTopicResults.length > 0;
    const isEvents = this.state.resultFilter === 'events';
    const hasEvents =  this.state.searchEventResults.length > 0;
    
    return (
      <React.Fragment>
        <LoaderComponent isLoading={isSubMenuDataLoading} />
        <HelmetComponent
          title="Search | ausbiz"
          subject="false"
          description="false"
          keywords="false"
          noIndex="true"
        />
        <div className="contentWhite">
          <div
            className={`search-wrapper ${isLoggedin
              ? "headerLoggedIn"
              : `${this.props.location.pathname.indexOf("search") > 0
                ? "headerLoggedOut search"
                : "headerLoggedOut"
              }`
              }`}
          >
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="search-header-wrapper d-flex flex-row align-items-center">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                        <path fillRule="nonzero" d="M14.894 15.781l.884-.884a.754.754 0 0 0 .003-1.063l-3.115-3.115a.75.75 0 0 0-.532-.219h-.509A6.468 6.468 0 0 0 13 6.5C13 2.91 10.09 0 6.5 0S0 2.91 0 6.5 2.91 13 6.5 13c1.51 0 2.897-.513 4-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 0 0 1.06 0zM6.5 10.5c-2.21 0-4-1.788-4-4 0-2.21 1.787-4 4-4 2.21 0 4 1.787 4 4 0 2.21-1.788 4-4 4z" />
                      </svg>
                    </span>
                    <input
                      ref={input => {
                        this.searchInput = input;
                      }}
                      className="search-input flex-grow-1"
                      placeholder="Search for companies, experts, topics and news"
                      type="text"
                      onKeyPress={event => this.handleKeyPress(event)}
                      onChange={event => this.handleValueChange(event)}
                      onKeyUp={event => this.handleKeyUp(event)}
                      value={this.userInput}
                      autoComplete="off"
                    />
                    <span
                      className="clickableElement"
                      onClick={() => this.resetSearch(false)}
                    >Clear
                      <img
                        src="/assets/svg/searchCross-black.svg"
                        alt="seach-cross"
                        onClick={() => this.resetSearch(true)}
                      />
                      {/* DO NOT REMOVE THIS BEAMER CODE */}
                      <a
                        id="callBeamer"
                        data-beamer-keypress="true"
                        style={{ visibility: "hidden", display: 'none' }}
                      >
                        What's New
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div
                className="col-12 searchResults"
                ref={this.lazyLoadContainer}
              >
                {globalTotalResult > 0 && (
                  <div>
                    <h5 className="showing-result-para">
                      Showing results for:
                      <span className="show-result">
                        &nbsp;{this.state.userInput}&nbsp;
                      </span>
                    </h5>                    
                    <div className="filter-video-results">
                      <span>Sort by: </span>
                      <span onClick={() => {
                        this.setState({queryFilter: 'newest'})
                      }} className={`filter-option ${this.state.queryFilter === 'newest' && 'selected'}`}>Most recent</span>
                      <span onClick={() => {
                        this.setState({queryFilter: 'oldest'})
                      }} className={`filter-option ${this.state.queryFilter === 'oldest' && 'selected'}`}>Relevancy</span>
                    </div>
                    <span className="filter-video-results">Display results for: </span>
                    <div className="search-filter-tabs">
                      {hasVideos && 
                        <span className={`${isVideos ? 'selected' : ''}`} onClick={() => {this.setState({resultFilter: 'videos'})}}>
                          VIDEOS
                        </span>
                      }
                      {hasSeries && 
                        <span className={`${isSeries ? 'selected' : ''}`} onClick={() => {this.setState({resultFilter: 'series'})}}>
                          SERIES
                        </span>
                      }
                      {hasCompanies &&
                        <span className={`${isCompanies ? 'selected' : ''}`} onClick={() => {this.setState({resultFilter: 'companies'})}}>
                          COMPANIES
                        </span>
                      }
                      {hasExperts &&
                        <span className={`${isExperts ? 'selected' : ''}`} onClick={() => {this.setState({resultFilter: 'experts'})}}>
                          EXPERTS
                        </span>
                      }
                      {hasTopics &&
                        <span className={`${isTopics ? 'selected' : ''}`} onClick={() => {this.setState({resultFilter: 'topics'})}}>
                          TOPICS
                        </span>
                      }
                      {hasEvents &&
                        <span className={`${isEvents ? 'selected' : ''}`} onClick={() => {this.setState({resultFilter: 'events'})}}>
                          EVENTS
                        </span>
                      }
                    </div>
                  </div>
                )}
                {hasEvents && isEvents &&
                  <EventList
                    searchObjectResults={this.state.searchEventResults}
                    title="EVENTS"
                    objectType="event"
                  />
                }
                {hasCompanies && isCompanies &&
                  <ObjectList
                    searchObjectResults={this.state.searchCompanyResults}
                    title="COMPANIES"
                    objectType="company"
                    followObject={this.followObject}
                    redirectionFn={redirectToCompanyUrl}
                    showLoader={this.props.showLoader}
                    hideLoader={this.props.hideLoader}
                  />
                }
                {hasExperts && isExperts &&
                  <ObjectList
                    searchObjectResults={this.state.searchExpertResults}
                    title="EXPERTS"
                    objectType="expert"
                    followObject={this.followObject}
                    redirectionFn={redirectToExpertUrl}
                    showLoader={this.props.showLoader}
                    hideLoader={this.props.hideLoader}
                  />
                }
                {hasSeries && isSeries &&
                  <ObjectList
                    searchObjectResults={this.state.searchSeriesResults}
                    title="SERIES"
                    objectType="series"
                    followObject={this.followObject}
                    redirectionFn={redirectToSeriesUrl}
                    showLoader={this.props.showLoader}
                    hideLoader={this.props.hideLoader}
                  />
                }
                {hasTopics && isTopics &&
                  <TopicList
                    searchObjectResults={this.state.searchTopicResults}
                    title="TOPICS"
                    objectType="topic"
                    followObject={this.followObject}
                    redirectionFn={redirectToUrl}
                    showLoader={this.props.showLoader}
                    hideLoader={this.props.hideLoader}
                    currentLanguage={this.props.currentLanguage}
                  />
                }
                {hasVideos && isVideos &&
                  <div className="topics-suggetion">
                    <VideoListingComponent
                      listing={listing}
                      videoCount={globalTotalResult}
                    />
                  </div>
                }
                {IsEmpty(this.state.userInput) && listing && listing.length == 0 &&
                  <NoSearchResults />
                }
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
}

function mapStateToProps(state) {
  return {
    searchReducer: state.search,
    token: state.auth.token,
    currentLanguage: state.language.currentLanguage
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getVodSearchDataAction,
      resetSearchResults,
      showLoader,
      hideLoader,
      setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
    },
    dispatch
  );
}

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(Search)
};
